import { EmptyState } from "@corecrm/ui";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <EmptyState
      action={
        <Link className="btn" to="/">
          Go to Home
        </Link>
      }
    >
      This page doesn't exist.
    </EmptyState>
  );
}
